import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { UITellHack } from '../UITellHack';
import styles from './index.less';
export var UIButton = function (props) {
    var style = props.style, className = props.className, icon = props.icon, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.type, type = _b === void 0 ? 'button' : _b, _c = props.telNumber, telNumber = _c === void 0 ? '' : _c, onClick = props.onClick, children = props.children, contentStyle = props.contentStyle;
    var View = useComponents().View;
    var disabledClass = disabled ? styles['button-disabled'] : '';
    var buttonClass = styles['button-container'] + " " + disabledClass + " " + className;
    var handleClick = function () {
        if (disabled)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    var buttonChildren = React.useMemo(function () { return (React.createElement(React.Fragment, null,
        icon && React.createElement(View, { className: styles['button-icon'] }, icon),
        children && React.createElement(View, { className: styles['button-content'], style: contentStyle }, children))); }, [icon, children]);
    return (React.createElement(View, { className: styles['button-warpper'] }, type === 'tel' ? (React.createElement(View, { className: buttonClass, style: style },
        React.createElement(UITellHack, { onClick: handleClick, telNumber: telNumber }, buttonChildren))) : (React.createElement(View, { className: buttonClass, style: style, onClick: function () { return handleClick(); } }, buttonChildren))));
};
